import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentComerciantes } from '@environments/environment';
import { Evaluation } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class EvaluationService {
    constructor(private http: HttpClient) { }

    get() {
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Evaluation/Get`);
    }

    getById(idEvaluation) {
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Evaluation/GetByID?id=${idEvaluation}`);
    }

    getResultById(idEvaluation){
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Evaluation/GetResultByID?id=${idEvaluation}`);
    }

    getContract(idEvaluation){
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Evaluation/GetResultByID?id=${idEvaluation}`);
    }

    /*getCertificate(idEvaluation){
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Certificate/GetByEvaluationId?id=${idEvaluation}`);
    }*/
    getCertificate(idEvaluation){
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Certificate/GetByEvaluationId?id=${idEvaluation}`);
    }
    getCertificatePDFbyEvalID(){
        return `${environmentComerciantes.apiUrl}/Certificate/GetByIdPDF?id=`;
    }


    SendObservations(observations){
        return this.http.post<any>(`${environmentComerciantes.apiUrl}/Evaluation/SendObservations`,observations);
    }

    finishEvaluation(evaluation) {
        let json = {
            'EvaluationID' : evaluation.evaluationID
        }
        return this.http.post<any>(`${environmentComerciantes.apiUrl}/Evaluation/EvaluationFinish`,json);
    }

    insertApplication(application: Evaluation) {
        return this.http.post<any>(`${environmentComerciantes.apiUrl}/Evaluation/InsertOrUpdate`,application );
    }

    insertApplicationTest(application: Evaluation) {
        return this.http.post<any>(`${environmentComerciantes.apiUrl}/Evaluation/InsertOrUpdateTest`,application );
    }

   
}